/* app/js/src/components/content-control/studio/content-control-studio/shared-objects/pause-icon/pause-icon.component.scss */
:host {
  display: flex;
}
/*# sourceMappingURL=pause-icon.component.css.map */
